import styled from "styled-components";

export const FormContainer = styled.form`
  display: grid;
  gap: 15px;
`

export const ButtonsContainer = styled.div`
`